// 2) Third-party library imports
import { get } from 'lodash-es';
import { all, fork, put, takeLatest, call } from 'redux-saga/effects';

// 3a) Constants
import { API_NAME } from '../../config/config';

// 3b) Custom hooks
// (none)

// 3c) Project-specific modules - components
import { _queries as queries } from '../../graphql/queries.graphql';

// 3d) Utility functions
import client, { post, del, delApi } from 'src/api';
import { DynamicObject } from '../../utils/commonInterfaces';

// 3e) Redux actions & types
import type { ApplicationState } from '../storeTypes';
import {
    initialState,
    createAccessTokenRequestAction,
    getAccessTokensRequestAction,
    getAccessTokensSuccessAction,
    revokeAccessTokensRequestAction,
    revokeAccessTokensResponseAction,
} from './accessTokenSlice';

export const getCurrentUser = (state: ApplicationState) =>
    state.auth.currentUser;

/**
 * Function that connects to get accessTokens and role for company api.
 */
function* handleGetAccessTokensRequest() {
    try {
        const res: DynamicObject = yield call(
            [client, client.graphql],
            {
                query: queries.GET_API_USERS_FOR_COMPANY
            }
        );

        const { ApiUsers } = get(res.data, 'GetApiUsersForCompany');
        const responsePayload = {
            data: ApiUsers,
        };

        yield put(getAccessTokensSuccessAction(responsePayload));
    }
    catch (err) {
        if (err instanceof Error) {
            console.log('Error', err);
        }
        else {
            console.error('An unknown error occured.', err);
        }

        yield put(
            getAccessTokensSuccessAction({
                data: initialState.data,
            })
        );
    }
}

/**
 * Function that connects to revoke the access tokens of the selected users.
 */
function* handleRevokeAccessTokensRequest({ payload: sagaPayload }: any) {
    const { key, callback } = sagaPayload;
    const payload = {
        Key: key,
    };

    try {
        yield call(delApi, `/company/token`, payload);

        if (callback) {
            const res: DynamicObject = {
                IsSuccess: true,
            };

            callback(res);
        }
        yield put(revokeAccessTokensResponseAction());
    }
    catch (err) {
        console.log('err: ', err);

        if (callback) {
            let returnData;

            if (err instanceof Error && 'response' in err && (err as any).response.body) {
                returnData = JSON.parse((err as any).response.body);
            } else if (err instanceof Error) {
                returnData = { Messages: [err.message] };
            } else {
                returnData = { Messages: ['An unknown error occurred.'] };
            }

            returnData.IsSuccess = false;
            callback(returnData);
        }
        yield put(revokeAccessTokensResponseAction());

        if (err instanceof Error) {
            console.log('Error', err);
        } else {
            console.error('An unknown error occurred.');
        }
        //if (callback) {
        //    const returnData = get(err.response, 'data')
        //        ? err.response.data
        //        : { Messages: [err.message] };
        //    returnData.IsSuccess = false;
        //    callback(returnData);
        //}
        //yield put(revokeAccessTokensResponseAction());

        //if (err instanceof Error) {
        //    console.log('Error', err);
        //} else {
        //    console.error('An unknown error occured.');
        //}
    }
}

/**
 * Function that connects to revoke the access tokens of the selected users.
 */
function* handleCreateAccessTokenRequest({ payload: sagaPayload }: any) {
    const { payload, callback } = sagaPayload;

    try {
        const { body } = yield call(post, {
            apiName: API_NAME,
            path: '/company/token',
            options: {
                body: payload
            }
        });

        const res: DynamicObject = yield body.json();
        if (callback) {
            res.IsSuccess = true;

            callback(res);
        }
    }
    catch (err) {
        console.log('err: ', err);

        if (callback) {
            let returnData;

            if (err instanceof Error && 'response' in err && (err as any).response.body) {
                returnData = JSON.parse((err as any).response.body);
            } else if (err instanceof Error) {
                returnData = { Messages: [err.message] };
            } else {
                returnData = { Messages: ['An unknown error occurred.'] };
            }

            returnData.IsSuccess = false;
            callback(returnData);
        }

        if (err instanceof Error) {
            console.log('Error', err);
        } else {
            console.error('An unknown error occurred.');
        }
        //if (callback) {
        //    const returnData = get(err.response, 'data')
        //        ? err.response.data
        //        : { Messages: [err.message] };
        //    returnData.IsSuccess = false;
        //    callback(returnData);
        //}
        //if (err instanceof Error) {
        //    console.log('Error', err);
        //} else {
        //    console.error('An unknown error occured.');
        //}
    }
}

// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchGetAccessTokensRequest() {
    yield takeLatest(
        getAccessTokensRequestAction.type,
        handleGetAccessTokensRequest
    );
}

function* watchRevokeAccessTokensRequest() {
    yield takeLatest(
        revokeAccessTokensRequestAction.type,
        handleRevokeAccessTokensRequest
    );
}

function* watchCreateAccessTokenRequest() {
    yield takeLatest(
        createAccessTokenRequestAction.type,
        handleCreateAccessTokenRequest
    );
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* accessTokensSaga() {
    yield all([
        fork(watchGetAccessTokensRequest),
        fork(watchRevokeAccessTokensRequest),
        fork(watchCreateAccessTokenRequest),
    ]);
}

export default accessTokensSaga;
